import { configureStore } from '@reduxjs/toolkit';

import { api } from '~shared/api/origin';
import { retentionApi } from '~shared/api/retention';

import authSlice from './auth/authSlice';
import chatVideoGenerationSlice from './chat-video-generation';
import emailConfirmSlice from './email-confirm';
import { clientInit } from './middlewares/clientInit';
import { apiErrorLogger } from './middlewares/error';
import { wsEventListener } from './middlewares/eventListener';
import { imageLoadingTrackingInit } from './middlewares/image-loading-tracking-init';
import { messageThrottlingNotificator } from './middlewares/message-throttling-notificator';
import { nsfwModalAuthListener } from './middlewares/nsfwModalAuthListener';
import { pushNotificationsInit } from './middlewares/pushNotificationsInit';
import { trackingMiddleware } from './middlewares/tracking';
import { typingIndicatorDataProcessing } from './middlewares/typing-indicator-data-processing';
import { userData } from './middlewares/userData';
import safeModeModalSlice from './safe-mode-modal';

export const createStore = () =>
	configureStore({
		reducer: {
			[api.reducerPath]: api.reducer,
			[retentionApi.reducerPath]: retentionApi.reducer,
			auth: authSlice,
			emailConfirm: emailConfirmSlice,
			chatVideoGeneration: chatVideoGenerationSlice,
			safeModeModal: safeModeModalSlice,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(
				api.middleware,
				retentionApi.middleware,
				apiErrorLogger,
				clientInit.middleware,
				pushNotificationsInit.middleware,
				imageLoadingTrackingInit.middleware,
				messageThrottlingNotificator.middleware,
				wsEventListener.middleware,
				userData.middleware,
				trackingMiddleware.middleware,
				typingIndicatorDataProcessing.middleware,
				nsfwModalAuthListener.middleware
			),
		devTools: process.env.NODE_ENV !== 'production',
	});

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
